import React from 'react';

import classNames from './EABDCircleButton.module.scss';
import { StyleUtil } from 'ui/util';

type CircleButtonArrowDirection = 'left' | 'right';

export interface CircleButtonProps
  extends Readonly<{
    arrowDirection: CircleButtonArrowDirection;
    onPress: () => void;
    isDisabled?: boolean;
    isStatic?: boolean;
  }> {}

export const CircleButton = React.memo<CircleButtonProps>((props) => {
  const { arrowDirection, onPress, isDisabled = false, isStatic = false } = props;

  const ButtonClassNames = React.useMemo(() => {
    const buttonClassNames: string[] = [classNames.button];

    if (isStatic) {
      buttonClassNames.push(classNames.static);
    }

    return StyleUtil.mergeClassNames(buttonClassNames);
  }, [isStatic]);

  const ArrowElement = React.useMemo(() => {
    const arrowClassNames: string[] = [classNames.arrow];

    switch (arrowDirection) {
      case 'left':
        arrowClassNames.push(classNames.left);
        break;
      case 'right':
        arrowClassNames.push(classNames.right);
        break;
    }

    return <div className={StyleUtil.mergeClassNames(arrowClassNames)} />;
  }, [arrowDirection]);

  return (
    <button onClick={onPress} disabled={isDisabled} type={'button'} className={ButtonClassNames}>
      {ArrowElement}
    </button>
  );
});
